(function () {
  'use strict'

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers').controller('ShowCompanyInsuranceController', ShowCompanyInsuranceController)

  ShowCompanyInsuranceController.$inject = ['$rootScope', 'CompanyService', 'NotificationService']

  function ShowCompanyInsuranceController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.companyInsurance')

    var vmShowInsuranceCtrl = this

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmShowInsuranceCtrl.metadata = data

        if (!('company_insurance' in vmShowInsuranceCtrl.metadata.allow)) {
          vmShowInsuranceCtrl.metadata.allow.company_insurance = false
        }
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    vmShowInsuranceCtrl.enable = function () {
      CompanyService
        .saveMetadata(vmShowInsuranceCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data
          NotificationService.successHandler(data, $rootScope.labels.saveConfig)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
        })
    }
  }
// eslint-disable-next-line semi
})();